import { useLang } from '@/i18n';
import EcoStickyFullScreenCard from 'eco-design/sections-test/eco-sticky-full-screen-card';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.SectionB1');

    return (
        <div className={styles.comp}>
            <EcoStickyFullScreenCard title={t('title')} pc={'https://websiteoss.ecoflow.com/upload/image/1741258431043/aaa1.jpg'} />
        </div>
    );
}
